import { Suspense } from 'react';
import type { ComponentProps } from 'react';

import { ErrorBoundary } from 'react-error-boundary';

import { NOTIFICATION_MESSAGES } from '@/shared/lib/constants/messages';
import { ErrorFallback } from '@/shared/ui/ErrorBoundary';
import { SuspenseFallback } from '@/shared/ui/SuspenseFallback';

import { ConnectorDashboard, ConnectorTableContent } from '@/widgets/connectors';

import styles from './ConnectorsPage.module.css';

const TITLE = 'Dashboard';
const DASHBOARD_CARD_HEIGHT = 108;

const renderDashboardErrorFallback = (fallbackProps: ComponentProps<typeof ErrorFallback>) => (
  <ErrorFallback
    className={styles.dashboardErrorFallback}
    variant="compact"
    height={DASHBOARD_CARD_HEIGHT}
    title={NOTIFICATION_MESSAGES.CONNECTOR_LIST_ERROR}
    description={NOTIFICATION_MESSAGES.CONNECTOR_LIST_ERROR_DESC}
    {...fallbackProps}
  />
);

const renderResultsErrorFallback = (fallbackProps: ComponentProps<typeof ErrorFallback>) => (
  <ErrorFallback
    className={styles.resultsErrorFallback}
    title={NOTIFICATION_MESSAGES.CONNECTOR_LIST_ERROR}
    description={NOTIFICATION_MESSAGES.CONNECTOR_LIST_ERROR_DESC}
    {...fallbackProps}
  />
);

const RESULTS_SUSPENSE_FALLBACK = <SuspenseFallback className={styles.resultsSuspenseFallback} />;

export const ConnectorsPage = () => {
  return (
    <div className={styles.connectorsPage}>
      <div className={styles.header}>
        <h1 className={styles.title}>{TITLE}</h1>
      </div>
      <div className={styles.dashboardArea}>
        <div className={styles.dashboardSlot}>
          <ErrorBoundary fallbackRender={renderDashboardErrorFallback}>
            <ConnectorDashboard />
          </ErrorBoundary>
        </div>
      </div>
      <div className={styles.resultsArea}>
        <h2 className={styles.connectorsTitle}>Connectors</h2>
        <div className={styles.resultsSlot}>
          <ErrorBoundary fallbackRender={renderResultsErrorFallback}>
            <Suspense fallback={RESULTS_SUSPENSE_FALLBACK}>
              <ConnectorTableContent />
            </Suspense>
          </ErrorBoundary>
        </div>
      </div>
    </div>
  );
};
